/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/accessibility_medium'
export default icon
